/**
 * Base Cache Strategy
 * Base class for cache strategy implementations
 */

import { CACHE_STRATEGIES } from '@/constants/gameConstants'
import { cacheService } from './cacheService'

export class BaseCacheStrategy {
  constructor(key) {
    this.key = key
    this.cacheService = cacheService
  }

  /**
   * Get cache configuration for this strategy
   * @returns {Object} Cache configuration
   */
  getConfig() {
    return CACHE_STRATEGIES[this.key] || { strategy: 'end-of-day' }
  }

  /**
   * Set data in cache using strategy configuration
   * @param {*} data - Data to cache
   */
  set(data) {
    const config = this.getConfig()
    this.cacheService.set(this.key, data, config.strategy, config.hours || 0)
  }

  /**
   * Get data from cache
   * @returns {*} Cached data or empty array for game data
   */
  get() {
    const data = this.cacheService.get(this.key)
    return data || []
  }

  /**
   * Check if cache is valid
   * @returns {boolean} True if valid
   */
  isValid() {
    return this.cacheService.isValid(this.key)
  }

  /**
   * Get countdown information
   * @returns {Object|null} Countdown info
   */
  getCountdown() {
    return this.cacheService.getCountdown(this.key)
  }

  /**
   * Remove cached data
   */
  remove() {
    this.cacheService.remove(this.key)
  }
}

export default BaseCacheStrategy
